import { observer } from 'mobx-react';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PlantingGraph } from './graph';
import { isPresent } from '@farmai-shared/LFUtils';
import { PlantingSunburst } from './sunburst';
import { PlantingResponse } from '@services/responseTypes';
import { InfoCircle } from '@components/icons';
export const Planting: FC<{
  stats: PlantingResponse | undefined;
}> = observer(({
  stats
}) => {
  const {
    t
  } = useTranslation();
  const hasCreated = isPresent(stats?.totals.created) && stats.totals.created > 0;
  const hasPlanted = isPresent(stats?.totals.planted) && stats.totals.planted > 0;
  const hasReady = isPresent(stats?.totals.ready_to_harvest) && stats.totals.ready_to_harvest > 0;
  const hasHarvested = isPresent(stats?.totals.harvested) && stats.totals.harvested > 0;
  return <div className={`
          keep-together
          print:ml-24
        `}>
        <div className={`
            flex flex-row items-center gap-x-2
            print:block
          `}>
          <h1 className={`
              block text-3xl
              print:hidden
            `}>
            {t('cropProgress')}
          </h1>
          <div className="print:hidden" data-tooltip-id="mobile-enabled-tooltip" data-tooltip-content={t('plantingGraph_summary')}>
            <InfoCircle height={18} width={18} stroke="#fff" fill="#727D9F" />
          </div>
        </div>

        <div className={`
            flex w-full flex-col gap-4
            lg:flex-row-reverse
            print:ml-12 print:flex-col-reverse
          `}>
          <div className={`
              w-full
              lg:w-1/4
            `}>
            <PlantingSunburst data={stats?.totals} hasDataToDisplay={hasCreated || hasPlanted || hasReady || hasHarvested} />
            <hr className={`
                my-20 hidden h-px w-full border-silver bg-gray-300
                print:block
              `} />
          </div>

          <div className={`
              keep-together w-full
              lg:w-3/4
              print:mt-12 print:block
            `}>
            <h1 className={`
                hidden text-3xl
                print:my-8 print:block print:text-4xl print:font-bold
              `}>
              {t('cropProgress')}
            </h1>
            <PlantingGraph data={stats?.series} hasDataToDisplay={hasCreated || hasPlanted || hasReady || hasHarvested} />
            <hr className={`
                my-20 hidden h-px w-full border-silver bg-gray-300
                print:block
              `} />
          </div>
        </div>
      </div>;
});